export const actionTypes = {
    loading: "LOADING_ACTION",
    delete: "DELETE_ACTION",
    loadedOne: "LOADED_ACTION",
    loadedMultiple: "LOADED_ACTIONS",
    success: "SUCCESS_ACTION",
    restore: "RESTORE_ACTION",
    hardDelete: "HARDDELETE_ACTION",
};
